import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/landing/src/app/blog/[slug]/BlogPostClient.js");
